function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("symbol", {
  id: "map_pin",
  viewBox: "0 0 24 24",
  fill: "none",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  id: "calendar",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 18,
  height: 18,
  rx: 2,
  ry: 2
}), /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 2,
  x2: 16,
  y2: 6
}), /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 2,
  x2: 8,
  y2: 6
}), /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 10,
  x2: 21,
  y2: 10
}));

var _ref4 = /*#__PURE__*/React.createElement("symbol", {
  id: "mail",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ">\n\t\t", /*#__PURE__*/React.createElement("path", {
  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "22,6 12,13 2,6"
}));

var _ref5 = /*#__PURE__*/React.createElement("symbol", {
  id: "notification",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ">\n\t\t", /*#__PURE__*/React.createElement("path", {
  d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.73 21a2 2 0 0 1-3.46 0"
}));

var _ref6 = /*#__PURE__*/React.createElement("symbol", {
  id: "search",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ">\n\t\t", /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 8
}), /*#__PURE__*/React.createElement("line", {
  x1: 21,
  y1: 21,
  x2: 16.65,
  y2: 16.65
}));

var _ref7 = /*#__PURE__*/React.createElement("symbol", {
  id: "home",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ">\n\t\t", /*#__PURE__*/React.createElement("path", {
  d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "9 22 9 12 15 12 15 22"
}));

var _ref8 = /*#__PURE__*/React.createElement("symbol", {
  id: "heart",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
}));

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 19,
  y1: 12,
  x2: 5,
  y2: 12
});

var _ref10 = /*#__PURE__*/React.createElement("polyline", {
  points: "12 19 5 12 12 5"
});

var _ref11 = /*#__PURE__*/React.createElement("symbol", {
  viewBox: "0 0 21 21",
  id: "message",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
}));

var _ref12 = /*#__PURE__*/React.createElement("symbol", {
  id: "share",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16 6 12 2 8 6"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 2,
  x2: 12,
  y2: 15
}));

var _ref13 = /*#__PURE__*/React.createElement("symbol", {
  id: "profile",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4
}));

var _ref14 = /*#__PURE__*/React.createElement("symbol", {
  id: "exit",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currrentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "16 17 21 12 16 7"
}), /*#__PURE__*/React.createElement("line", {
  x1: 21,
  y1: 12,
  x2: 9,
  y2: 12
}));

var _ref15 = /*#__PURE__*/React.createElement("symbol", {
  id: "news",
  viewBox: "0 0 512 512"
}, /*#__PURE__*/React.createElement("path", {
  d: "M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328",
  fill: "none",
  stroke: "currrentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
}), /*#__PURE__*/React.createElement("path", {
  d: "M416 464h0a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48z",
  fill: "none",
  stroke: "currrentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currrentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32,
  d: "M240 128h64M240 192h64M112 256h192M112 320h192M112 384h192"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z"
}));

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    visibility: "hidden",
    style: {
      visibility: "hidden",
      position: "absolute",
      pointerEvents: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_left",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currrentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref9, _ref10), _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.7d0629b3.svg";
export { ForwardRef as ReactComponent };